import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {localhost} from "../config/backend-api";
import {Observable, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})

// Questo service serve per tenere aggiornata la toolbar. Utilizzato solo per i messaggi al momento.
export class ToolbarService {
  //public messageUnreadPresent = false;
  messageUnreadPresentChange: Subject<boolean> = new Subject<boolean>();

  constructor(private httpClient: HttpClient) {

    document.addEventListener('new-chat-message', () => {
      console.log(true);
      this.updateMessageUnreadBadge(true);
    });
  }

  getNumberMessagesUnread(){
    return this.httpClient.get<number>(localhost + 'private/chat/number-messages-unread')
  }

  // true se ci sono messaggi da leggere; false altrimenti.
  updateMessageUnreadBadge(messagesUnread: boolean){
    /*this.mutex
      .acquire()
      .then((release) => {
        //this.messageUnreadPresent = messagesUnread;
        this.messageUnreadPresentChange.next(messagesUnread);
        release();
      });*/
    this.messageUnreadPresentChange.next(messagesUnread);
  }

  getMessageUnreadObs(){
    return this.messageUnreadPresentChange;
  }
}
